// extracted by mini-css-extract-plugin
export default {"link":"aa0BzVXDUs"};